import { instance } from '../api/api';
import { ICar } from '../types/type';
import { formatDateForApi } from '../utils/date.utils';
import { toBackendDate } from '../utils/utils';

// Интерфейсы для путевых листов
export interface ICarImage {
  carID: string;
  createdAt: string;
  id: string;
  photoType: string;
  photoUrl: string;
}

export interface IRoadListItem {
  autopark: {
    actualAddress: string;
    balance: number;
    bankName: string;
    bik: string;
    currentAccount: string;
    email: string;
    fullnameEmployee: string;
    fullnameOwner: string;
    id: string;
    inn: string;
    kpp: string;
    legalAddress: string;
    legalName: string;
    ogrn: string;
    phone: string;
    tradeName: string;
  };
  car: ICar;
  date: string;
  driver: {
    birthDate: string;
    licenseNumber: string;
    licenseSer: string;
    healthRestrictions: boolean;
    id: string;
    licenseExpireDate: string;
    licenseIssueDate: string;
    sex: string;
    snils: string;
  };
  id: string;
  medlist: {
    bloodAlcohol: number;
    bloodPressure: string;
    bodyTemperature: number;
    checkTime: string;
    driverID: string;
    heartRate: number;
    id: string;
    medicID: string;
    num: number;
    reasonForRefusal: string;
    saturation: number;
    selfie: string;
    status: string;
    symptomsPresent: boolean;
  };
  num: number;
  status: string;
  techlist: {
    body: boolean;
    carID: string;
    chassis: boolean;
    checkStatus: string;
    checkTime: string;
    engine: boolean;
    id: string;
    num: number;
    odometerReading: number;
    optic: boolean;
    reasonForRefusal: string;
    technicID: string;
  };
  url: string;
}

export interface IRoadListResponse {
  data: IRoadListItem[];
  page: number;
  totalCount: number;
  totalPages: number;
}

export interface RoadListFilters {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
  autoparkID?: string;
  startTime?: string;
  endTime?: string;
}

export const RoadListService = {
  // Получение списка путевых листов водителя
  async getDriverRoadLists(driverID: string, filters: RoadListFilters = {}): Promise<IRoadListResponse> {
    try {
      const queryParams = new URLSearchParams();

      // Копируем фильтры и форматируем даты
      const formattedFilters = { ...filters };

      // Форматируем даты, если они есть
      if (filters.startDate) {
        formattedFilters.startDate = formatDateForApi(filters.startDate);
      }

      if (filters.endDate) {
        formattedFilters.endDate = formatDateForApi(filters.endDate);
      }
      if (filters.startTime) {
        formattedFilters.startTime = formatDateForApi(filters.startTime);
      }

      if (filters.endTime) {
        formattedFilters.endTime = formatDateForApi(filters.endTime);
      }

      // Добавляем параметры в URL
      Object.entries(formattedFilters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });
      console.log('formattedFilters: ', formattedFilters);

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const { data } = await instance.get<IRoadListResponse>(`/roadlist/driver/${driverID}${queryString}`);

      return data;
    } catch (error: any) {
      console.error('Ошибка при получении путевых листов:', error);
      throw new Error(error.response?.data?.message || 'Не удалось получить путевые листы водителя');
    }
  },

  // Получение одного путевого листа по ID
  async getRoadListById(roadlistId: string): Promise<IRoadListItem> {
    try {
      const { data } = await instance.get<IRoadListItem>(`/roadlist/${roadlistId}`);
      return data;
    } catch (error: any) {
      console.error('Ошибка при получении путевого листа:', error);
      throw new Error(error.response?.data?.message || 'Не удалось получить путевой лист');
    }
  },

  async getRoadlists(filters: RoadListFilters = {}): Promise<IRoadListResponse> {
    try {
      const queryParams = new URLSearchParams();

      // Копируем фильтры и форматируем даты
      const formattedFilters = { ...filters };

      // Форматируем даты, если они есть
      if (filters.startDate) {
        formattedFilters.startDate = toBackendDate(filters.startDate);
      }

      if (filters.endDate) {
        formattedFilters.endDate = toBackendDate(filters.endDate);
      }

      // Добавляем параметры в URL
      Object.entries(formattedFilters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const { data } = await instance.get<IRoadListResponse>(`/roadlist${queryString}`);
      return data;
    } catch (error: any) {
      console.error('Ошибка при получении путевых листов:', error);
      throw new Error(error.response?.data?.message || 'Не удалось получить путевые листы');
    }
  },
};
